function scaleAllHTML5Banners() {
  const bannerContainers = document.querySelectorAll( '.banner-container' );

  if (bannerContainers) {
    [...bannerContainers].forEach( container => {
      const parentContainerWidth = container.parentElement.offsetWidth - (2 * parseInt( getComputedStyle( container.parentElement ).paddingInline, 10 ));
      const originalWidth = container.style.getPropertyValue( '--aspect-ratio-w' );
      const originalHeight = container.style.getPropertyValue( '--aspect-ratio-h' );
      const zoom = Math.min( 1, parentContainerWidth / originalWidth );

      container.parentElement.style.height = Math.ceil( zoom * originalHeight ) + 'px';
      container.style.setProperty( '--zoom', zoom );
    } );
  }
}

export default {
  init() {
    scaleAllHTML5Banners();
    window.addEventListener( 'resize', scaleAllHTML5Banners );
  },
};